import {Box, Pagination} from '@mui/material';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {
  getCustomers,
  getCustomersByBuilding,
  getCustomersByEntrance,
} from '../actions';
import {Filters} from '.';
import useFilters from '../utils/useFilters';
import CustomersTable from './CustomTables/CustomersTable';

const CustomersTab = ({entrance, building}) => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const {
    customers,
    buildingCustomers,
    entranceCustomers,
    customersLoading,
    customersPage,
    customersTotalPages,
    buildingCustomersPage,
    buildingCustomersTotalPages,
    entranceCustomersPage,
    entranceCustomersTotalPages,
  } = useSelector(s => s.customers);

  const page = entrance
    ? entranceCustomersPage
    : building
    ? buildingCustomersPage
    : customersPage;
  const count = entrance
    ? entranceCustomersTotalPages
    : building
    ? buildingCustomersTotalPages
    : customersTotalPages;
  const data = entrance
    ? entranceCustomers
    : building
    ? buildingCustomers
    : customers;

  const filters = useFilters(val =>
    entrance
      ? dispatch(getCustomersByEntrance(id, val))
      : building
      ? dispatch(getCustomersByBuilding(id, val))
      : dispatch(getCustomers(val)),
  );

  const onPageChange = (e, value) => {
    if (entrance) {
      dispatch(getCustomersByEntrance(id, {page: value, ...filters.filters}));
    } else if (building) {
      dispatch(getCustomersByBuilding(id, {page: value, ...filters.filters}));
    } else {
      dispatch(getCustomers({page: value, ...filters.filters}));
    }
  };

  return (
    <>
      {!!entrance || !!building ? (
        <Box position="absolute" zIndex={1}>
          <Filters m="0 !important" withSearch {...filters} />
        </Box>
      ) : (
        <Filters m="1rem" withSearch withBuilding {...filters} />
      )}
      <CustomersTable
        customers={data}
        loading={customersLoading}
        hideAddBtn={!entrance && !building}
      />
      {count > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination count={count} page={page} onChange={onPageChange} />
        </Box>
      )}
    </>
  );
};

export default CustomersTab;
